import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { INavbarConf } from '@devinforius/i-essentials/lib/interfaces';
import { SsoService } from '@devinforius/i-sso';
import { UserInfo, UserInfosDetails } from 'src/app/shared/models/iCourrier/me/user-info';
import { MeService } from 'src/app/shared/services/me.service';
import { environment } from 'src/environments/environment';


@Component({
  selector: 'app-private-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})
export class HomePrivateComponent implements OnInit {
  constructor(
    private router: Router,
    private meService: MeService,
    private ssoService: SsoService
  ) { }
  public user: UserInfosDetails;
  public logout: () => void;

  public isLoaded = false;
  public navbarConfig: INavbarConf;

  ngOnInit(): void {
    this.logout = () => {
      this.logoutFct();
    };
    this.getUser();
    this.goTo();
  }

  private goTo(): void {
    this.router.navigateByUrl('/private/ic/courriers');
  }

  public getUser(): void {
    this.meService.getUserInfo().subscribe({
      next: (res: UserInfo) => {
        this.user = new UserInfosDetails(res);
        this.user.firstname = res.userName;
        if (!this.user.avatar) {
          this.user.avatar = './assets/img/avatar.svg';
        }
        this.setNavbarConfig();
      },
    });
  }

  public logoutFct(): void {
    this.ssoService.logOut();
    localStorage.removeItem('iCourrierBoxes');
    this.router.navigate(['/public/home']);
  }

  private setNavbarConfig() {
    const navbarConfig: INavbarConf = {
      options: [],
      langs: [],
      user: { lastname: '', firstname: this.user.firstname, fullname: this.user.firstname },
      app: 'iCourrier',
      home: '',
      environment: !environment.production ? (environment.environmentTitle as 'DEV' | 'ACC' | 'PROD' | 'LCL') : undefined,
      links: [],
      version: '6.2.0',

      toAssistance: () => {
        this.router.navigateByUrl('/private/ic/assistance');
      },
    };
    this.navbarConfig = navbarConfig;
    this.isLoaded = true;
  }
}
